module.exports = __webpack_public_path__ + "img/meiyoushangpin.b7d05064.png";